<template>
    <div class="qrcode">
        <div id="reader"></div>
        <span class="close-scan" @click="stop()"><svg t="1681382339822" class="icon" viewBox="0 0 1024 1024"
                                                        version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2626"
                                                        width="200" height="200"><path
                d="M512 960c-247.039484 0-448-200.960516-448-448S264.960516 64 512 64 960 264.960516 960 512 759.039484 960 512 960zM512 128.287273c-211.584464 0-383.712727 172.128262-383.712727 383.712727 0 211.551781 172.128262 383.712727 383.712727 383.712727 211.551781 0 383.712727-172.159226 383.712727-383.712727C895.712727 300.415536 723.551781 128.287273 512 128.287273z"
                fill="#ffffff" p-id="2627"></path><path
                d="M557.05545 513.376159l138.367639-136.864185c12.576374-12.416396 12.672705-32.671738 0.25631-45.248112s-32.704421-12.672705-45.248112-0.25631l-138.560301 137.024163-136.447897-136.864185c-12.512727-12.512727-32.735385-12.576374-45.248112-0.063647-12.512727 12.480043-12.54369 32.735385-0.063647 45.248112l136.255235 136.671523-137.376804 135.904314c-12.576374 12.447359-12.672705 32.671738-0.25631 45.248112 6.271845 6.335493 14.496116 9.504099 22.751351 9.504099 8.12794 0 16.25588-3.103239 22.496761-9.247789l137.567746-136.064292 138.687596 139.136568c6.240882 6.271845 14.432469 9.407768 22.65674 9.407768 8.191587 0 16.352211-3.135923 22.591372-9.34412 12.512727-12.480043 12.54369-32.704421 0.063647-45.248112L557.05545 513.376159z"
                fill="#ffffff" p-id="2628"></path></svg></span>

    </div>
</template>

<script>
    import {Html5Qrcode} from "html5-qrcode";

    export default {
        created() {
            this.getCameras()
        },
        beforeDestroy() {
            this.stop();
        },
        methods: {
            getCameras() {
                Html5Qrcode.getCameras()
                    .then((devices) => {
                        if (devices && devices.length) {
                            this.html5QrCode = new Html5Qrcode("reader");
                            this.start();
                        }
                    })
                    .catch((err) => {
                        // handle err
                        this.html5QrCode = new Html5Qrcode("reader");
                        this.error = "ERROR: 您需要授予相机访问权限"
                        this.$emit("err", this.error)
                    });
            },
            start() {
                //environment后置 user前置
                this.html5QrCode
                    .start(
                        {facingMode: "user"},
                        {
                            fps: 2,
                            qrbox: {width: 500, height: 500},
                        },
                        (decodedText, decodedResult) => {
                            this.$emit("ok", decodedText)
                        }
                    )
                    .catch((err) => {
                        this.$emit("err", err)
                    });
            },
            stop() {
                this.$emit("stop")

                // this.html5QrCode.stop().then((ignore) => {
                //     // QR Code scanning is stopped.
                //     console.log("QR Code scanning stopped.");
                // })
                //     .catch((err) => {
                //         // Stop failed, handle it.
                //         console.log("Unable to stop scanning.");
                //     });
            },
        }
    }
</script>

<style scoped>
    .qrcode {
        position: relative;
        height: 100%;
        width: 100%;
        background: rgba(0, 0, 0, 0.48);
    }

    #reader {
        top: 50%;
        left: 0;
        transform: translateY(-50%);
    }
    .close-scan {
        position: absolute;
        top: 20px;
        right: 20px;
    }
    .close-scan svg {
        width: 40px;
        height: 40px;
    }
</style>
